import React from 'react';

import { Box, Inline } from '@atlaskit/primitives/compiled';
import { Card } from '@atlaskit/smart-card';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/close';

import type { AdditionalResource } from '../../../../../types/additionalResource';

const styles = cssMap({
	smartLinkContainer: {
		maxHeight: '24px',
	},
	buttonContainer: {
		paddingInline: token('space.050'),
	},
});

export type AdditionalResourceSelectionProps = {
	resource: AdditionalResource;
	removeResource: (url: string) => void;
};

export const AdditionalResourceSelection = ({
	resource,
	removeResource,
}: AdditionalResourceSelectionProps) => {
	const { url } = resource;

	return (
		<Inline spread="space-between" xcss={styles.smartLinkContainer}>
			<Card url={url} appearance="inline" truncateInline />
			<Box xcss={styles.buttonContainer}>
				<IconButton
					label="remove-briefing-resource"
					appearance="subtle"
					icon={CloseIcon}
					spacing="compact"
					onClick={() => removeResource(url)}
				/>
			</Box>
		</Inline>
	);
};
